import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  container: {
    marginTop: 8,
  },
  label: {
    display: 'block',
    fontWeight: 600,
  },
  note: {
    margin: 0,
    color: '#747474',
  },
}))
